const BaseComponent = require('base/base-component');

class List extends BaseComponent {}
module.exports = List;
